export default __webpack_public_path__ + "static/media/graph-selected.c4a41dcc.svg";